// extracted by mini-css-extract-plugin
export default {"row":"YZ5WK","skeleton-progress":"DSYPM"};